import { PluginConfigType } from "@intelligems/ig-types/schemas/plugin/config/config";
import { PluginMetaType } from "@intelligems/ig-types/schemas/plugin/config/meta/meta";
import { api } from "@src/api/api";

export const getPluginConfig = async (
  shortOrgId: string
): Promise<PluginMetaType | undefined> => {
  const resp = await api.get<PluginConfigType>(
    `/v2/organizations/configs/${shortOrgId}`
  );
  return resp.data?.meta;
};
